import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {markdownComponents} from '@/matic/features/_shared/components/markdown/markdown-components';

type MarkdownFieldTextProps = {
  value: string;
};

/**
 * Renders a long-text field value (MDM Tribal Knowledge, description, and
 * other conventionally-freeform fields — see LONG_TEXT_FIELD_KEYS) as
 * formatted markdown instead of a plain string. The field is still edited as
 * raw markdown source in a plain textarea — this only changes how the
 * read-only detail view displays it.
 */
export function MarkdownFieldText({value}: MarkdownFieldTextProps) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
      {value}
    </ReactMarkdown>
  );
}
